module.exports = __webpack_public_path__ + "static/media/galerija_2017 (31).f3481914.jpg";